"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cccisdFormik = require("cccisd-formik");
var _style = _interopRequireDefault(require("../style.css"));
var _utils = _interopRequireDefault(require("./utils"));
var _Variables = _interopRequireDefault(require("./Variables"));
var _Verify = _interopRequireDefault(require("./Verify"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Equation = function Equation(_ref) {
  var updatingVariableId = _ref.updatingVariableId,
    values = _ref.values;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showExamples = _useState2[0],
    setShowExamples = _useState2[1];
  var matchedVariables = _utils["default"].matchAllVariables(values.equation);
  var usedLabel = function usedLabel(variable) {
    var usageCount = _utils["default"].usageCount(matchedVariables, variable);
    if (usageCount === 0) {
      return "used 0 times";
    }
    if (usageCount === 1) {
      return "used 1 time";
    }
    return "used ".concat(usageCount, " times");
  };
  var placeholder = function placeholder() {
    if (!values.variables.length) {
      return null;
    }
    return "(".concat(values.variables.join(' + '), " + 10) / 100");
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Variables["default"], {
    updatingVariableId: updatingVariableId
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "control-label"
  }, "Variables"), !!(values.variables || []).length && /*#__PURE__*/_react["default"].createElement("ul", null, values.variables.map(function (variable) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: variable
    }, variable, " (", usedLabel(variable), ")");
  })), !(values.variables || []).length && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].equationNothingSelected
  }, /*#__PURE__*/_react["default"].createElement("i", null, "Nothing selected")))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: showExamples ? 'col-xs-8' : 'col-xs-12'
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "equation",
    component: _cccisdFormik.CccisdTextarea,
    placeholder: placeholder(),
    rows: "5",
    label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Equation", /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn-link",
      onClick: function onClick() {
        return setShowExamples(!showExamples);
      }
    }, showExamples ? 'Hide examples' : 'Show examples'))
  })), showExamples && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('col-xs-4', _style["default"].equationVerifyExamples)
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "control-label"
  }, "Examples"), /*#__PURE__*/_react["default"].createElement("ol", null, /*#__PURE__*/_react["default"].createElement("li", null, "var_a - 10"), /*#__PURE__*/_react["default"].createElement("li", null, "(var_a + var_b) * 2"), /*#__PURE__*/_react["default"].createElement("li", null, "(var_a ^ 3) / 100")))), /*#__PURE__*/_react["default"].createElement(_Verify["default"], {
    values: values
  }));
};
var _default = exports["default"] = Equation;